import React, { useEffect, useState } from "react";
import trans, { isRTL } from "../../../../utils";
import OfflineFormHeader from "../../OfflineFormControl/OfflineFormHeader/OfflineFormHeader";
import { Segmented } from "antd";
import IROfflineFormSubmission from "./IROfflineFormSubmission";
import IROfflineFormInformation from "./IROfflineFormInformation";
import OfflineFormFooter from "../../OfflineFormControl/OfflineFormFooter/OfflineFormFooter";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { editData, storeData } from "../../../../utils/IndexedDB";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function IROfflineForm({
	formBody,
	formEditData,
	setRoomId,
	roomId,
}) {
	const [activeOption, setActiveOption] = useState("information");
	const steps = [
		{ label: trans("information"), value: "information" },
		{ label: trans("form submission"), value: "form submission" },
	];
	const [submitData, setSubmitData] = useState(
		formBody?.formSchemas?.[0]?.formSchema || [],
	);
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [formReqVal, setformReqVal] = useState(null);
	const step = steps?.findIndex((i) => i?.value === activeOption);
	const navigate = useNavigate();
	const param = useParams();
	let initialValues = {
		type: "IR",
		project_id: null,
		discipline: null,
		zone_id: null,
		level_id: null, // building_id maps to level_id in IR
		room_id: null, // level (space poiId) maps to room_id in IR
		room_name: null,
		ready_date: null,
		form_id: null,
		fields: null,
		removed_attachments: [],
		edit_notes: "",
	};
	let validSchema = Yup.object({
		room_id: Yup.string().required(trans("Space is required")),
		ready_date: Yup.string().required(trans("Ready Date is required")),
	});
	const inf = useSelector((state) => state.users.user);
	let addIR = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				if (!param?.id) {
					await storeData("OfflineModeData", "IR", `IR-${Date.now()}`, {
						id: Date.now(),
						userId: inf?.id,
						syncTime: null,
						configurationName: formBody?.name,
						statusSync: "Pending Sync",
						...val,
					});
					toast.success(trans("IR Form Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				} else {
					const updatedFields = val.fields.map((field) => {
						const newValue = submitData.find((item) => item.key === field.key);

						return newValue ? { ...field, value: newValue.value } : field;
					});

					await editData("OfflineModeData", "IR", param.id, {
						...val,
						configurationName: formBody?.name,
						fields: updatedFields,
						id: param.id,
						statusSync: "Pending Sync",
					});

					toast.success(trans("IR Form Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					});
				}

				navigate("/IR");
				// }
			} catch (error) {
				console.log("errr", error);
			}
		},
	});
	useEffect(() => {
		if (!param?.id) {
			const initialFields =
				formBody?.formSchemas?.[0]?.formSchema?.fields || [];

			const fieldsWithValues = initialFields.map((field) => {
				const submittedValue = submitData.find(
					(item) => item.key === field.key,
				);

				return submittedValue
					? { ...field, value: submittedValue.value }
					: field;
			});

			addIR.setFieldValue("fields", fieldsWithValues);
		}
	}, [submitData, param?.id]);
	useEffect(() => {
		addIR.setFieldValue("project_id", formBody?.project?.id);
		addIR.setFieldValue("level_id", formBody?.level?.id);
		addIR.setFieldValue("project_name", formBody?.project?.name);
		addIR.setFieldValue("level_name", formBody?.level?.name);

		if (!param?.id) {
			addIR.setFieldValue("zone_id", formBody?.building?.id);
			addIR.setFieldValue("zone_name", formBody?.building?.name);
			addIR.setFieldValue(
				"form_id",
				formBody?.modules
					?.filter((j) => j.module === "IR")
					?.map((i) => {
						return i.formId;
					})?.[0],
			);
			addIR.setFieldValue("form_name", formBody?.formSchemas?.[0]?.name);
			addIR.setFieldValue(
				"discipline",
				formBody?.modules
					?.filter((j) => j.module === "IR")
					?.map((i) => {
						return i.discipline;
					})?.[0],
			);
		} else {
			addIR.setFieldValue("zone_id", formEditData?.zone_id);
			addIR.setFieldValue("zone_name", formEditData?.zone_name);
			addIR.setFieldValue("form_id", formEditData?.form_id);
			addIR.setFieldValue("form_name", formEditData?.form_name);
			addIR.setFieldValue("discipline", formEditData?.discipline);
			addIR.setFieldValue("room_id", formEditData?.room_id);
			addIR.setFieldValue("room_name", formEditData?.room_name);
			addIR.setFieldValue("fields", formEditData?.fields);
			addIR.setFieldValue("ready_date", formEditData?.ready_date);
		}
	}, [formBody, param.id]);
	console.log("FormBody", formBody);
	console.log("submitData", submitData);
	// useEffect(() => {
	// 	addIR.setFieldValue("fields", submitData);
	// }, [submitData]);
	useEffect(() => {
		if (formReqVal && formReqVal.length > 0) {
			const updatedMissingFields = formReqVal.filter((field) => {
				const submittedField = submitData.find((i) => i.key === field.key);

				// Check if field is still missing/invalid
				return (
					!submittedField ||
					submittedField.value === "" ||
					submittedField.value === undefined ||
					submittedField.value === "[]" ||
					submittedField.value.length === 0
				);
			});

			// Update only if changed
			if (updatedMissingFields.length !== formReqVal.length) {
				setformReqVal(
					updatedMissingFields.length > 0 ? updatedMissingFields : null,
				);
			}
		}
	}, [submitData, formReqVal]);
	useEffect(() => {
		if (roomId) {
			addIR.setFieldValue("room_id", roomId);
			const roomLabel = formBody?.rooms?.find(
				(i) => i?.poiId === roomId,
			)?.displayName;
			addIR.setFieldValue("room_name", roomLabel);
		}
	}, [roomId]);
	const handleSubmit = async (e) => {
		e.preventDefault();
		setSubmitAttempt(true);

		// Helper: Flatten fields including containers
		const flattenFields = (fields) => {
			return fields.flatMap((field) => {
				if (field.name === "Container" && Array.isArray(field.container)) {
					return [field, ...flattenFields(field.container)];
				}
				return field;
			});
		};

		const allFields = flattenFields(
			!param?.id
				? formBody?.formSchemas?.[0]?.formSchema?.fields
				: formEditData?.fields,
		);

		let updatedSubmitData = [...submitData];

		const missingRequiredFields = allFields.filter((field) => {
			const submittedField = updatedSubmitData.find((i) => i.key === field.key);
			const isRequired = field?.required?.value;

			// Special case: Checkbox & Toggle
			if (["Checkbox", "Toggle"].includes(field.name)) {
				if (!submittedField) {
					updatedSubmitData.push({
						key: field.key,
						name: field.name,
						title: field.title,
						value: false, // ✅ default false
					});
					return isRequired; // still missing if required
				}
				return false;
			}

			// Normal required input
			return (
				isRequired &&
				(!submittedField ||
					submittedField.value === "" ||
					submittedField.value === undefined ||
					submittedField.value === "[]" ||
					submittedField.value.length === 0)
			);
		});
		if (missingRequiredFields.length > 0) {
			setformReqVal(missingRequiredFields);
			missingRequiredFields.forEach((field) => {
				addIR.setFieldTouched(`fields[${field.key}].value`, true, false);
			});
			await addIR.validateForm();
			// ✅ Update with default checkbox/toggle values if added
			setSubmitData(updatedSubmitData);

			console.warn("Missing required:", missingRequiredFields);
			return; // ❌ stop submitting
		}

		// ✅ Submit now passes all validation
		setSubmitData(updatedSubmitData);
		addIR.handleSubmit(e);
	};
	console.log("IRDATA", addIR);
	console.log("roomId", roomId);
	const disableNext = () => {
		if (step === 0) {
			if (
				addIR.values.ready_date === null ||
				addIR.errors.ready_date ||
				addIR.values.room_id === null ||
				addIR.errors.room_id
			) {
				return true;
			}
		} else {
			return false;
		}
	};
	let disable = disableNext();
	const next = (e) => {
		e.preventDefault();

		if (disable) {
			addIR.setFieldTouched("ready_date", true);
			addIR.setFieldTouched("room_id", true);

			if (addIR.values.ready_date === null || addIR.errors.ready_date) {
				addIR.setFieldError("ready_date", trans("Ready Date is required"));
			}
			if (addIR.values.room_id === null || addIR.errors.room_id) {
				addIR.setFieldError("room_id", trans("Room is required"));
			}

			return;
		}

		if (step < steps.length - 1) {
			setActiveOption(steps[step + 1].value);
		}
	};
	const back = (e) => {
		e.preventDefault();

		if (step > 0) {
			setActiveOption(steps[step - 1].value);
		}
	};
	return (
		<div className="col-lg-5">
			<form
				onSubmit={handleSubmit}
				style={{
					width: "100%",
					backgroundColor: "white",
					height: "calc(100vh - 64px)",
					display: "flex",
					flexDirection: "column",
					borderLeft: !isRTL && "1px solid #D2D5DC",
					borderRight: isRTL && "1px solid #D2D5DC",
				}}
			>
				<OfflineFormHeader
					title={
						!formEditData ? "New Inspection Request" : "Edit Inspection Request"
					}
					subtitle="Working Offline — Your data will sync when connection returns"
				/>
				<div
					style={{
						flex: 1,
						overflow: "auto",
						display: "flex",
						flexDirection: "column",
						minHeight: 0, // Important for proper scrolling
					}}
				>
					<Segmented
						options={steps.map((i, index) => ({
							label: i.label,
							value: i.value,
						}))}
						style={{ textTransform: "capitalize", marginBottom: "12px" }}
						onChange={(value) => {
							if (disable) {
								addIR.setFieldTouched("ready_date", true);
								addIR.setFieldTouched("room_id", true);

								if (
									addIR.values.ready_date === null ||
									addIR.errors.ready_date
								) {
									addIR.setFieldError(
										"ready_date",
										trans("Ready Date is required"),
									);
								}
								if (addIR.values.room_id === null || addIR.errors.room_id) {
									addIR.setFieldError("room_id", trans("Room is required"));
								}

								return;
							}
							setActiveOption(value);
							if (value === "information" || activeOption === "information") {
								// addIR.setFieldTouched("ready_date", true, true);
							}
						}}
						onClick={(value) => {
							if (disable) {
								addIR.setFieldTouched("ready_date", true);
								addIR.setFieldTouched("room_id", true);

								if (
									addIR.values.ready_date === null ||
									addIR.errors.ready_date
								) {
									addIR.setFieldError(
										"ready_date",
										trans("Ready Date is required"),
									);
								}
								if (addIR.values.room_id === null || addIR.errors.room_id) {
									addIR.setFieldError("room_id", trans("Room is required"));
								}

								return;
							}
							if (value === "information" || activeOption === "information") {
								// addIR.setFieldTouched("ready_date", true, true);
							}
						}}
						value={activeOption}
						size="large"
						block
					/>
					{activeOption === "information" && (
						<IROfflineFormInformation
							formBody={formBody}
							addData={addIR}
							roomId={roomId}
							formEditData={formEditData}
							setRoomId={setRoomId}
						/>
					)}
					{activeOption === "form submission" && (
						<IROfflineFormSubmission
							formBody={formBody}
							formEditData={formEditData?.fields}
							setSubmitData={setSubmitData}
							submitData={submitData}
							addData={addIR}
						/>
					)}
					<OfflineFormFooter
						step={step}
						steps={steps}
						mutlipage={true}
						next={next}
						back={back}
						submitAttempt={submitAttempt}
						addConfig={addIR}
						disable={disable}
						formReqVal={formReqVal}
						route="IR"
					/>
				</div>
			</form>
		</div>
	);
}
